import { render, staticRenderFns } from "./Lgx241890469603180544.vue?vue&type=template&id=4e37cd69&scoped=true&"
import script from "./Lgx241890469603180544.vue?vue&type=script&lang=js&"
export * from "./Lgx241890469603180544.vue?vue&type=script&lang=js&"
import style0 from "./Lgx241890469603180544.vue?vue&type=style&index=0&id=4e37cd69&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e37cd69",
  null
  
)

export default component.exports